import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to scroll to top of page when route changes
 * Helps fix issues where page doesn't reload after navigation in production builds
 */
export const useScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top
        window.scrollTo(0, 0);

        // Force a layout reflow to ensure components are properly rendered
        window.dispatchEvent(new Event('resize'));
    }, [pathname]);
};
